module.exports = __webpack_public_path__ + "img/xuchang.d58a7b1d.png";